import type { ReactElement } from 'react';
import './LoaderVariant2.css';

export function LoaderVariant2(): ReactElement {
  return <div className="lv2" />;
}
